module.exports = __webpack_public_path__ + "static/media/personal-dosimetry-settings.ad3a5400.svg";